import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/apiServices';
import { queryKeys } from '../config/queryClient';
import { DashboardOverview, DashboardMetrics, AlertsResponse } from '../types';

// Dashboard Overview
export const useDashboardOverview = () => {
  return useQuery<DashboardOverview>({
    queryKey: queryKeys.dashboardOverview,
    queryFn: dashboardService.getOverview,
  });
};

// Dashboard Metrics
export const useDashboardMetrics = () => {
  return useQuery<DashboardMetrics>({
    queryKey: queryKeys.dashboardMetrics,
    queryFn: dashboardService.getMetrics,
  });
};

// Dashboard Alerts
export const useDashboardAlerts = () => {
  return useQuery<AlertsResponse>({
    queryKey: queryKeys.dashboardAlerts,
    queryFn: dashboardService.getAlerts,
  });
};

// Bird Overview
export const useBirdOverview = (birdId: number, enabled = true) => {
  return useQuery({
    queryKey: queryKeys.dashboardBird(birdId),
    queryFn: () => dashboardService.getBirdOverview(birdId),
    enabled,
  });
};

// Daily Overview
export const useDailyOverview = () => {
  return useQuery({
    queryKey: queryKeys.dashboardDaily,
    queryFn: dashboardService.getDailyOverview,
  });
};
